import { render, staticRenderFns } from "./WYSIWYG.vue?vue&type=template&id=309f5a1d&"
import script from "./WYSIWYG.vue?vue&type=script&lang=ts&"
export * from "./WYSIWYG.vue?vue&type=script&lang=ts&"
import style0 from "./WYSIWYG.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports